import * as d3 from 'd3'
export default {
  methods: {

    draw_Legends() {

      let legendsGroup = this.canvasForms
      .append('g')
      .attr('id', `LEGEND_GROUP_${this.localId}`)
      .attr('transform',`translate(${this.legends.x}, ${this.legends.y})`)

      if(this.legends.direct == 'horizontal') {
        let x = 0
        this.rawData.forEach((d,i)=> {

          let item = legendsGroup
          .append('g')
          .attr('id', `LEGEND_ITEM_${i}_${this.localId}`)
          .call(this.pie_Link, this.colorSet[i], i)

          item
          .append('rect')
          .attr('x', x).attr('y', -5)
          .attr('width', 10).attr('height', 10)
          .attr('fill', (d.color.substr(0,1) == '#') ? d.color : `url(#${this.localId}_${d.color}_)`)
          .attr('opacity', d.opacity)

          item
          .append('text')
          .attr('id', `LEGEND_NAME_${i}_${this.localId}`)
          .attr('x', x + 15).attr('y', .5 + this.legends.tSize*0.36)
          .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
          .text(`${d.NAME} (${d.VALUE.toFixed(this.guide.value.round) + this.guide.value.unit})`)

          x = x + this.getNode(`#LEGEND_NAME_${i}_${this.localId}`, 'width') + 25
        })
        let groupWidth = this.legends.x - (this.getNode(`#LEGEND_GROUP_${this.localId}`, 'width') / 2)
        d3.select(`#LEGEND_GROUP_${this.localId}`).attr('transform',`translate(${groupWidth}, ${this.legends.y})`)

      } else if(this.legends.direct == 'vertical') {

        let y = 0
        this.rawData.forEach((d,i)=> {
          let item = legendsGroup
          .append('g')
          .call(this.pie_Link, this.colorSet[i], i)

          item
          .append('rect')
          .attr('x', 0).attr('y', y - 5)
          .attr('width', 10).attr('height', 10)
          .attr('fill', (d.color.substr(0,1) == '#') ? d.color : `url(#${this.localId}_${d.color}_)`)
          .attr('opacity', d.opacity)

          item
          .append('text')
          .attr('id', `LEGEND_NAME_${i}_${this.localId}`)
          .attr('x', 15).attr('y', y + .5 + this.legends.tSize*0.36)
          .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
          .text(`${d.NAME} (${d.VALUE.toFixed(this.guide.value.round) + this.guide.value.unit})`)
          
          y = y + 20
        })
      }


      if(this.legends.align == 'middle' && this.legends.direct == 'horizontal') {
        let x_ = this.circle.cx - (this.getNode(`#LEGEND_GROUP_${this.localId}`) / 2)
        d3.select(`#LEGEND_GROUP_${this.localId}`).attr('transform',`translate(${x_}, ${this.legends.y})`)
      }

      if(this.legends.align == 'middle' && this.legends.direct == 'vertical') {
        let y_ = this.circle.cy - (this.getNode(`#LEGEND_GROUP_${this.localId}`, 'height') / 2) 
        d3.select(`#LEGEND_GROUP_${this.localId}`).attr('transform',`translate(${this.legends.x}, ${this.legends.y})`)
      }

    },


    

  }
}
